/**
 * 报表中心列展示入口图标
 */
export function ColumnDisplayIcon() {
  return (
    <svg
      data-slot="column-display-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M12.9478 6.36158L10.5266 2.168C10.2993 1.77425 9.87556 1.52966 9.42097 1.52966H4.57867C4.12408 1.52966 3.70039 1.77425 3.47302 2.168L1.05187 6.36158C0.824507 6.75533 0.824507 7.24451 1.05187 7.63826L3.47302 11.8318C3.70039 12.2256 4.12408 12.4702 4.57867 12.4702H9.42097C9.87556 12.4702 10.2993 12.2256 10.5266 11.8318L12.9478 7.63826C13.1751 7.24451 13.1751 6.75533 12.9478 6.36158ZM12.2847 7.25544L9.86353 11.449C9.77248 11.6067 9.60295 11.7045 9.42097 11.7045H4.57867C4.39669 11.7045 4.22703 11.6067 4.13611 11.449L1.71496 7.25544C1.6239 7.09781 1.6239 6.90203 1.71496 6.74439L4.13611 2.55082C4.22716 2.39318 4.39669 2.29529 4.57867 2.29529H9.42097C9.60295 2.29529 9.77261 2.39318 9.86353 2.55082L12.2847 6.74439C12.3757 6.90203 12.3757 7.09781 12.2847 7.25544Z"
        fill="currentColor"
      />
      <path
        d="M7 3.88281C6.16738 3.88281 5.38453 4.20711 4.79582 4.79582C4.20711 5.38453 3.88281 6.16738 3.88281 7C3.88281 7.83262 4.20711 8.61547 4.79582 9.20418C5.38453 9.79289 6.16738 10.1172 7 10.1172C7.83262 10.1172 8.61547 9.79289 9.20418 9.20418C9.79289 8.61547 10.1172 7.83262 10.1172 7C10.1172 6.16738 9.79289 5.38453 9.20418 4.79582C8.61547 4.20711 7.83262 3.88281 7 3.88281ZM7 9.35156C5.70336 9.35156 4.64844 8.29664 4.64844 7C4.64844 5.70336 5.70336 4.64844 7 4.64844C8.29664 4.64844 9.35156 5.70336 9.35156 7C9.35156 8.29664 8.29664 9.35156 7 9.35156Z"
        fill="currentColor"
      />
    </svg>
  );
}
